<template lang="pug">
.plaza-cont
    .row.plaza(:class="!isMobile? 'pc-plaza' : '' ")
        .col.image-item(v-for="item in data" )
            .image-box
                img(:src="item.imgUrl")

</template>
<script>

import util from   "../lib/util"
import $ from "jquery"
import Vue from 'vue'
export default {
    name: 'PhotoPlaza',
    data() {
        return {
            showPage: window.vueCfg.page,
            LANG: window.LANG,
            data: [],

            //loading Data
            reachedLast: false,
            isLoading: false,
            page: window.vueCfg.page,

            //hint
            isSupWebP: util.isSupWebP(),
            isMobile: util.isMobile()
        }
    },
    beforeMount : function(){
        let mThis = this;
        this.loadData();
        this.cssCompute();
        util.scrollBottom(function(){
            // console.log('reach last!!');
        },function(h){
            /*mThis.page ++;
            mThis.loadData();*/
            console.log(h);
            if ( h <= 200 ){
                mThis.page ++;
                mThis.loadData();
            }
        });
    },

    methods : {
        loadData(){
            var page = this.page , mThis = this;
            if (mThis.reachedLast){
                return console.log("last page");
            }
            if (mThis.isLoading){
                return console.log("isloading");
            }

            mThis.isLoading = true;
            var apiUrl = `/index/plaza/?ajax=1&page=${page}`;
            $.getJSON(apiUrl,(rep)=>{
                console.log(rep);
                mThis.isLoading = false;
                if ( rep.msg.list.length == 0 ){
                    mThis.reachedLast = true;
                    return;
                }
                mThis.data = mThis.data.concat(rep.msg.list);
            });
        },

        cssCompute(){
            var screenWidth = window.screen.width;
            console.log(screenWidth , ".screenWidth");
            var boxHeight = screenWidth / 2;
            $('body').append(`
            <style>.image-item{height: ${boxHeight}px!important;}</style>
            `);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/modules/PhotoPlaza.vue